import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { tokenStorage } from '../../shared/api/storage';
import { useMe } from 'core/me/provider/MeProvider';

export function PublicOnlyRoute({ children }) {
  const loc = useLocation();
  const tokens = tokenStorage.get();
  const { me, loading } = useMe();

  // Token yoksa public sayfaları göster
  if (!tokens?.accessToken) return <>{children}</>;

  // ✅ Token var ama me daha yükleniyor: hiçbir şey gösterme (flash biter)
  if (loading) return null;

  // Token var ama me yok -> token bozuk/expired olabilir -> public sayfayı göster
  if (!me) return <>{children}</>;

  // PENDING_EMAIL ise verify'e git
  if (me.status === 'PENDING_EMAIL') {
    // verify-email sayfasındaysan tekrar redirect yapma
    if (loc.pathname === '/verify-email') return <>{children}</>;
    return <Navigate to="/verify-email" replace state={{ email: me.email }} />;
  }

  // Normal kullanıcı: app'e git
  return <Navigate to="/app" replace />;
}

PublicOnlyRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
